// ======================================================================= Namespace
var ttl = ttl || {},
  $ = jQuery;

// =======================================================================  Mobile Menu
ttl.mobileMenu = {
  init: function() {
    // Toggle mobile menu on nav-toggle click
    $(".menu-toggle").on("click", function() {
      ttl.mobileMenu.toggleMenu();
    });

    // Toggle the sub menus in the mobile menu
    $(".sub-nav-toggle").on("click", function() {
      ttl.mobileMenu.toggleSubMenu($(this));
    });

    // On load, check if we need to expand the sub menus
    $(window).on("load", function() {
      ttl.mobileMenu.checkSubMenuActive();
    });

    // Hide mobile menu on resize
    $(window).on("resize", function() {
      if ($(window).width() > 1000) {
        ttl.mobileMenu.hideMenu();
      }
    });
  },

  // Toggle the menu to the state it currently doesn't have
  toggleMenu: function() {
    if ($("body").hasClass("showing-mobile-menu")) {
      ttl.mobileMenu.hideMenu();
    } else {
      ttl.mobileMenu.showMenu();
    }
  },

  // Show the mobile menu
  showMenu: function() {
    $(".menu-toggle").addClass("active");
    $(".menu-toggle").attr("aria-expanded", "true");
    $(".header-menu-wrapper").addClass("visible");
    $("body").addClass("showing-mobile-menu lock-scroll");
  },

  // Hide the mobile menu
  hideMenu: function() {
    $(".menu-toggle").removeClass("active");
    $(".menu-toggle").attr("aria-expanded", "false");
    $(".header-menu-wrapper").removeClass("visible");
    $("body").removeClass("showing-mobile-menu lock-scroll");
  },

  // Toggle sub menus
  toggleSubMenu: function($subNavToggle) {
    var $subMenu = $subNavToggle
      .parent(".menu-toggle-wrapper")
      .next(".sub-menu");

    $subNavToggle.toggleClass("active");
    $subMenu.slideToggle(400);
  },

  // On load, check whether we need to expand sub menus to show the current item
  checkSubMenuActive: function() {
    var $currentMenuItem = $(".header-menu-wrapper ul li.current-menu-item");

    // Find the current menu item, provided it is a sub item
    if ($currentMenuItem.length) {
      // Loop through each ancestor of the item and show/activate the sub nav elements
      $currentMenuItem.parents("li.current_page_ancestor").each(function() {
        $(this)
          .children(".menu-toggle-wrapper")
          .children(".sub-nav-toggle")
          .addClass("active");
        $(this)
          .children(".sub-menu")
          .show();
      });
    }
  }
}; // ttl.mobileMenu

// ======================================================================= Function calls
$(document).ready(function() {
  ttl.mobileMenu.init(); // Mobile menu
});
